import { useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { useGetAdminEstablishmentsQuery } from '@/core/services/admin'
import { useCreateContractMutation } from '@/core/services/contract'
import { useGetLicensesQuery } from '@/core/services/license'

import { getApiErrorMessage } from '@/utils/errors'

import ContractForm from '../components/ContractForm'

export default function CreateContractForm() {
  const location = useLocation()
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()

  const { data: establishments } = useGetAdminEstablishmentsQuery()
  const { data: licenses } = useGetLicensesQuery({})
  const [createContract, { isLoading: isCreatingContract }] = useCreateContractMutation()

  const establishmentOptions = useMemo(
    () =>
      establishments
        ?.filter((establishment) => !establishment.contract)
        .map((establishment) => ({
          label: establishment.name,
          value: establishment._id,
        })) ?? [],
    [establishments]
  )

  const licenseOptions = useMemo(
    () =>
      licenses
        ?.filter((license) => !license.isDefault)
        .map((license) => ({
          label: license.name,
          value: license._id,
        })) ?? [],
    [licenses]
  )

  return (
    <ContractForm
      establishmentOptions={establishmentOptions}
      isSubmitting={isCreatingContract}
      licenseOptions={licenseOptions}
      onSubmit={async (values) => {
        try {
          await createContract({
            name: values.name,
            establishment: values.establishment,
            licenseUsages: values.licenseUsages.map(({ license, quantity }) => ({
              license: license.id,
              quantity,
            })),
          }).unwrap()
          navigate(location.pathname.replace('/create', ''))
        } catch (error) {
          enqueueSnackbar(getApiErrorMessage(error, t('notification.accountGroup.create.error')), { variant: 'error' })
        }
      }}
    />
  )
}
